/* MARSH colour guide: shared helpers */
(function () {
  if (window.MarshColour) return;
  var load = function () {
    var el = document.getElementById('marsh-colours');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  };
  var match = function (colours, title, tags) {
    var t = String(title || '').toUpperCase().replace(/\s+/g, ' ').trim() + '|';
    var best = null;
    colours.forEach(function (c, i) {
      c.match.forEach(function (m) {
        var pre = t.charAt(t.length - m.length - 2);
        if (t.slice(-(m.length + 1)) === m + '|' && (pre === ' ' || pre === '/') && (!best || m.length > best.m.length)) best = { c: c, i: i, m: m };
      });
    });
    var base = best ? t.slice(0, -(best.m.length + 2)).trim() : t.slice(0, -1);
    var tag = String(tags || '').split('|').filter(function (x) { return /^colou?r:/i.test(x.trim()); })[0];
    if (tag) {
      var v = tag.split(':')[1].trim().toUpperCase();
      colours.forEach(function (c, i) { if (c.label.toUpperCase() === v || c.match.indexOf(v) > -1) best = { c: c, i: i, m: '' }; });
    }
    return { colour: best ? best.c : null, index: best ? best.i : 999, base: base };
  };
  var pretty = function (s) {
    return String(s).toLowerCase().split(' ').map(function (w) {
      if (w === 'tshirt') return 'T-shirt';
      return w.split('/').map(function (p) { return p.charAt(0).toUpperCase() + p.slice(1); }).join('/');
    }).join(' ');
  };
  var swatch = function (c) {
    if (!c) return 'transparent';
    if (c.pattern === 'stripe') return 'repeating-linear-gradient(90deg,' + c.hex + ' 0 4px,#F4F2EC 4px 7px)';
    if (c.pattern === 'check') return 'repeating-linear-gradient(90deg,' + c.hex + ' 0 4px,' + c.hex2 + ' 4px 8px),' + c.hex;
    if (c.pattern === 'multi') return 'conic-gradient(#8B2B23,#EAD27A,#3E8E4C,#2E5C98,#9B7A8C,#8B2B23)';
    return c.hex;
  };
  var svgFill = function (c, id) {
    if (c.pattern === 'stripe') return { defs: '<pattern id="' + id + '" width="12" height="12" patternUnits="userSpaceOnUse"><rect width="12" height="12" fill="' + c.hex + '"/><rect width="4" height="12" fill="#F4F2EC"/></pattern>', fill: 'url(#' + id + ')' };
    if (c.pattern === 'check') return { defs: '<pattern id="' + id + '" width="14" height="14" patternUnits="userSpaceOnUse"><rect width="14" height="14" fill="' + c.hex + '"/><rect width="7" height="14" fill="' + c.hex2 + '" opacity=".75"/><rect width="14" height="7" fill="' + c.hex2 + '" opacity=".5"/></pattern>', fill: 'url(#' + id + ')' };
    if (c.pattern === 'multi') return { defs: '<pattern id="' + id + '" width="40" height="10" patternUnits="userSpaceOnUse"><rect width="8" height="10" fill="#8B2B23"/><rect x="8" width="8" height="10" fill="#EAD27A"/><rect x="16" width="8" height="10" fill="#3E8E4C"/><rect x="24" width="8" height="10" fill="#2E5C98"/><rect x="32" width="8" height="10" fill="#9B7A8C"/></pattern>', fill: 'url(#' + id + ')' };
    return { defs: '', fill: c.hex };
  };
  var lum = function (hex) {
    var n = parseInt(hex.slice(1), 16);
    return (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
  };
  window.MarshColour = { load: load, match: match, pretty: pretty, swatch: swatch, svgFill: svgFill, lum: lum };
})();

/* Colour wheel + grouped grid */
(function () {
  if (customElements.get('marsh-colour-wheel')) return;
  var slug = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-'); };
  /* Shop grid leads with on-body photos: score each image by its file name and alt text */
  var bodyScore = function (img) {
    var f = String(img.u || '').split('?')[0].split('/').pop().toLowerCase(), a = String(img.a || '').toLowerCase(), sc = 0;
    if (/on-body|on model|worn|model/.test(a)) sc += 3;
    if (/^marsh_0202|^dscf|^img_|matched|on-body/.test(f)) sc += 2;
    if (/^[0-9a-f]{8}-[0-9a-f]{4}-/.test(f)) sc += 1;
    if (/flatlay|folded|flat lay|detail|embroidery|sleeve and hem|drawstring/.test(f + ' ' + a)) sc -= 3;
    if (/^\d{1,2}(_[0-9a-f-]+)?\.png$/.test(f)) sc -= 1;
    return sc;
  };
  var srcset = function (u) { return [360, 540, 720, 900].map(function (w) { return u.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w'; }).join(', '); };
  var leadWithBody = function (card) {
    var list; try { list = JSON.parse(card.dataset.imgs || '[]'); } catch (e) { return; }
    if (list.length < 2) return;
    var ranked = list.map(function (im, i) { return { im: im, i: i, s: bodyScore(im) }; }).sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    if (ranked[0].s <= 0) return;
    var a = card.querySelector('.mcw__img--a'), b = card.querySelector('.mcw__img--b');
    var setImg = function (el, im) { if (!el) return; el.src = im.u; el.srcset = srcset(im.u); };
    setImg(a, ranked[0].im);
    if (a && ranked[0].im.a) a.alt = ranked[0].im.a;
    var second = ranked[1] && ranked[1].s > 0 ? ranked[1] : null;
    if (b) { if (second) setImg(b, second.im); else { b.remove(); if (a) a.classList.remove('has-b'); } }
  };
  customElements.define('marsh-colour-wheel', class extends HTMLElement {
    connectedCallback() {
      var MC = window.MarshColour, self = this;
      this.updateSticky = function () {
        if (self.stickyFrame) return;
        self.stickyFrame = requestAnimationFrame(function () {
          self.stickyFrame = null;
          var header = document.querySelector('.section-header');
          var bottom = header ? header.getBoundingClientRect().bottom : 0;
          var position = header ? getComputedStyle(header).position : '';
          var offset = position === 'sticky' || position === 'fixed' ? Math.max(0, bottom) : 0;
          self.style.setProperty('--mcw-header-offset', Math.round(offset) + 'px');
        });
      };
      window.addEventListener('scroll', this.updateSticky, {passive:true});
      window.addEventListener('resize', this.updateSticky, {passive:true});
      this.updateSticky();
      var colours = MC.load();
      var pool = this.querySelector('[data-pool]'), holder = this.querySelector('[data-groups]');
      if (!pool || !holder) return;
      var cards = Array.prototype.slice.call(pool.children);
      this.state = { type: 'All', active: null };
      var byColour = {};
      cards.forEach(function (card, n) {
        var r = MC.match(colours, card.dataset.title, card.dataset.tags);
        card._order = n;
        var colour = r.colour;
        if (colour && colour.pattern === 'multi') { colour = colours.find(function(c){return c.label === 'Green';}) || colour; }
        if (colour && colour.pattern) { colour = colours.filter(function(c){return !c.pattern;}).sort(function(a,b){var rgb=function(h){return [1,3,5].map(function(i){return parseInt(h.slice(i,i+2),16);});}; var dist=function(c){return rgb(c.hex).reduce(function(n,v,i){return n+Math.pow(v-rgb(r.colour.hex)[i],2);},0);};return dist(a)-dist(b);})[0]; }
        var key = colour ? colour.label : 'Other';
        (byColour[key] = byColour[key] || []).push(card);
        var nm = card.querySelector('[data-name]'); if (nm) nm.textContent = MC.pretty(r.base);
        var ib = card.querySelector('.mcw__img--b'), ia = card.querySelector('.mcw__img--a');
        if (ib && ia) ia.classList.add('has-b');
        if (self.dataset.lead === 'body') leadWithBody(card);
      });
      var used = colours.filter(function (c) { return !c.pattern && byColour[c.label]; });
      if (byColour.Other) used.push({ label: 'Other', hex: '#cfcac0', ring: 'neutral' });
      this.used = used;
      this.groups = used.map(function (c) {
        var g = document.createElement('section');
        g.className = 'mcw__group'; g.id = self.id + '-' + slug(c.label); g.dataset.c = c.label;
        g.innerHTML = '<h3 class="mcw__ghead"><span class="mcw__gdot" style="background:' + MC.swatch(c) + '"></span><span>' + c.label + '</span><span class="mcw__gcount" data-count></span></h3><ul class="mcw__grid" role="list"></ul>';
        var ul = g.querySelector('ul');
        byColour[c.label].forEach(function (card) { ul.appendChild(card); });
        holder.appendChild(g);
        return g;
      });
      pool.remove();
      this.cards = cards;

      var nav = this.querySelector('[data-nav]');
      if (nav) {
        nav.innerHTML = used.map(function (c) {
          return '<a href="#' + self.id + '-' + slug(c.label) + '" data-c="' + c.label + '"><span class="mcw__ndot" style="background:' + MC.swatch(c) + '"></span><span class="mcw__nlab">' + c.label + '</span><span class="mcw__ncount" data-ncount></span></a>';
        }).join('');
        nav.addEventListener('click', function (e) { var a = e.target.closest('a'); if (!a) return; e.preventDefault(); self.go(a.dataset.c); });
      }

      var types = [];
      cards.forEach(function (c) { var t = c.dataset.group; if (t && types.indexOf(t) < 0) types.push(t); });
      var order = ['Tops', 'Shirts', 'Bottoms', 'Accessories'];
      types.sort(function (a, b) { return (order.indexOf(a) + 1 || 99) - (order.indexOf(b) + 1 || 99); });
      var tf = this.querySelector('[data-types]');
      if (tf && types.length > 1) {
        tf.innerHTML = ['All'].concat(types).map(function (t) { return '<button type="button" data-type="' + t + '" aria-pressed="' + (t === 'All') + '">' + t + '</button>'; }).join('');
        tf.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; self.state.type = b.dataset.type; self.apply(); });
      }

      this.buildWheel();
      this.apply();
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) self.setActive(en.target.closest('.mcw__group').dataset.c); });
        }, { rootMargin: '-25% 0px -65% 0px' });
        this.groups.forEach(function (g) { var card=g.querySelector('.mcw__card'); if(card) self.io.observe(card); });
      }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      window.removeEventListener('scroll', this.updateSticky);
      window.removeEventListener('resize', this.updateSticky);
      if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
    }

    go(label) {
      var g = this.querySelector('[data-c="' + label + '"].mcw__group');
      if (!g || g.hidden) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      (g.querySelector('.mcw__card:not([hidden])') || g).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      this.setActive(label);
    }

    setActive(label) {
      this.state.active = label;
      this.querySelectorAll('.mcw__seg').forEach(function (s) { s.classList.toggle('is-on', s.dataset.c === label); });
      this.querySelectorAll('[data-nav] a').forEach(function (a) { if (a.dataset.c === label) { a.setAttribute('aria-current', 'true'); if (a.parentNode.scrollWidth > a.parentNode.clientWidth) a.parentNode.scrollTo({ left: a.offsetLeft - 16, behavior: 'smooth' }); } else a.removeAttribute('aria-current'); });
      var w = this.querySelector('[data-wheel]'); if (w) w.classList.toggle('has-sel', !!label);
      this.centre(label);
    }

    buildWheel() {
      var MC = window.MarshColour, self = this, svg = this.querySelector('[data-wheel]');
      if (!svg) return;
      var used = this.used.filter(function (c) { return c.label !== 'Other'; });
      var hue = used.filter(function (c) { return c.ring !== 'neutral'; });
      var neu = used.filter(function (c) { return c.ring === 'neutral'; });
      var cx = 300, cy = 300;
      var pt = function (r, a) { a = a * Math.PI / 180; return (cx + r * Math.cos(a)).toFixed(2) + ',' + (cy + r * Math.sin(a)).toFixed(2); };
      var defs = '', html = '', k = 0;
      var ring = function (list, ro, ri, gap) {
        var n = list.length; if (!n) return;
        list.forEach(function (c, i) {
          var a0 = -90 + i * 360 / n + gap, a1 = -90 + (i + 1) * 360 / n - gap, large = (a1 - a0) > 180 ? 1 : 0;
          var f = MC.svgFill(c, 'mcwp-' + self.id + '-' + c.label.replace(/\W/g, ''));
          defs += f.defs;
          var edge = MC.lum(c.hex) > .85 && !c.pattern ? ' stroke="rgba(0,0,0,.2)" stroke-width="1.5"' : '';
          html += '<g class="mcw__seg" data-c="' + c.label + '" tabindex="0" role="button" aria-label="Jump to ' + c.label + '" style="--d:' + (k++ * 30) + 'ms"><title>' + c.label + '</title>' +
            '<path d="M' + pt(ro, a0) + ' A' + ro + ' ' + ro + ' 0 ' + large + ' 1 ' + pt(ro, a1) + ' L' + pt(ri, a1) + ' A' + ri + ' ' + ri + ' 0 ' + large + ' 0 ' + pt(ri, a0) + ' Z" fill="' + f.fill + '"' + edge + '/></g>';
        });
      };
      ring(hue, 296, 200, 1);
      ring(neu, 190, 128, 1.6);
      html += '<text class="mcw__c1" data-c1 x="300" y="300" text-anchor="middle"></text><text class="mcw__c2" data-c2 x="300" y="340" text-anchor="middle"></text>';
      svg.innerHTML = '<defs>' + defs + '</defs>' + html;
      svg.querySelectorAll('.mcw__seg').forEach(function (g) {
        var c = g.dataset.c;
        g.addEventListener('mouseenter', function () { self.centre(c); });
        g.addEventListener('mouseleave', function () { self.centre(self.state.active); });
        g.addEventListener('focus', function () { self.centre(c); });
        g.addEventListener('blur', function () { self.centre(self.state.active); });
        g.addEventListener('click', function () { self.go(c); });
        g.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.go(c); } });
      });
      this.centre(null);
    }

    centre(c) {
      var a = this.querySelector('[data-c1]'), b = this.querySelector('[data-c2]');
      if (!a) return;
      var n = c ? this.visibleCount(c) : 0;
      if (c) { a.textContent = c; b.textContent = n + (n === 1 ? ' piece' : ' pieces'); }
      else { a.textContent = this.dataset.centre || 'Colours'; b.textContent = this.used.length + ' colours'; }
    }

    visibleCount(label) {
      var g = this.querySelector('[data-c="' + label + '"].mcw__group');
      return g ? g.querySelectorAll('.mcw__card:not([hidden])').length : 0;
    }

    apply() {
      var s = this.state, self = this;
      this.cards.forEach(function (c) { c.hidden = !(s.type === 'All' || c.dataset.group === s.type); });
      this.groups.forEach(function (g) {
        var n = g.querySelectorAll('.mcw__card:not([hidden])').length;
        g.hidden = !n;
        g.querySelector('[data-count]').textContent = n;
        var a = self.querySelector('[data-nav] a[data-c="' + g.dataset.c + '"]');
        if (a) { a.hidden = !n; a.querySelector('[data-ncount]').textContent = n; }
        var seg = self.querySelector('.mcw__seg[data-c="' + g.dataset.c + '"]');
        if (seg) seg.classList.toggle('is-empty', !n);
      });
      this.querySelectorAll('[data-types] button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.type === s.type)); });
      this.centre(this.state.active);
    }
  });
})();

/* Colourways on the product page */
(function () {
  if (customElements.get('marsh-colourways')) return;
  customElements.define('marsh-colourways', class extends HTMLElement {
    connectedCallback() {
      var MC = window.MarshColour, colours = MC.load();
      var me = MC.match(colours, this.dataset.title, this.dataset.tags);
      var items = Array.prototype.slice.call(this.querySelectorAll('[data-sib]')).map(function (a) {
        return { el: a, r: MC.match(colours, a.dataset.title, a.dataset.tags) };
      }).filter(function (x) { return x.r.base === me.base && x.r.colour; });
      items.sort(function (a, b) { return a.r.index - b.r.index; });
      var list = this.querySelector('[data-list]'), label = this.querySelector('[data-label]');
      if (items.length < 2) { this.hidden = true; return; }
      items.forEach(function (x) {
        x.el.querySelector('[data-dot]').style.background = MC.swatch(x.r.colour);
        x.el.querySelector('[data-cname]').textContent = x.r.colour.label;
        list.appendChild(x.el);
        x.el.hidden = false;
      });
      if (label) label.textContent = (me.colour ? me.colour.label + ', ' : '') + 'also in ' + (items.length - 1) + ' more';
      this.hidden = false;
    }
  });
})();


